import * as Types from '../../types.generated';

import { api } from '../../rootApi';
export type GlobalSearchQueryVariables = Types.Exact<{
  searchQuery: Types.Scalars['String'];
}>;

export type GlobalSearchQuery = {
  __typename?: 'Query';
  artistList: {
    __typename?: 'ArtistList';
    data?:
      | Array<{
          __typename?: 'Artist';
          id: number;
          firstName: string;
          lastName?: string | null | undefined;
          profilePicture?:
            | { __typename?: 'Attachment'; url: string }
            | null
            | undefined;
        }>
      | null
      | undefined;
  };
  instrumentList: {
    __typename?: 'MusicalInstrumentList';
    data?:
      | Array<{
          __typename?: 'MusicalInstrument';
          id: number;
          name: string;
          profilePicture?:
            | { __typename?: 'Attachment'; url: string }
            | null
            | undefined;
        }>
      | null
      | undefined;
  };
  ragaList: {
    __typename?: 'RagaList';
    data?:
      | Array<{
          __typename?: 'Raga';
          id: number;
          title: string;
          timeSections?:
            | Array<{
                __typename?: 'TimeSection';
                profilePicture?:
                  | { __typename?: 'Attachment'; id: number; url: string }
                  | null
                  | undefined;
              }>
            | null
            | undefined;
        }>
      | null
      | undefined;
  };
};

export const GlobalSearchDocument = `
    query GlobalSearch($searchQuery: String!) {
  artistList(perPage: 20, page: 1, searchQuery: $searchQuery) {
    data {
      id
      firstName
      lastName
      profilePicture {
        url
      }
    }
  }
  instrumentList(perPage: 20, page: 1, searchQuery: $searchQuery) {
    data {
      id
      name
      profilePicture {
        url
      }
    }
  }
  ragaList(perPage: 20, page: 1, searchQuery: $searchQuery) {
    data {
      id
      title
      timeSections {
        profilePicture {
          id
          url
        }
      }
    }
  }
}
    `;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    GlobalSearch: build.query<GlobalSearchQuery, GlobalSearchQueryVariables>({
      query: (variables) => ({ document: GlobalSearchDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const { useGlobalSearchQuery, useLazyGlobalSearchQuery } =
  injectedRtkApi;
